module.exports = __webpack_public_path__ + "img/25.1f80b2ac.png";